import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5689524a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel, useDebounceFn } from '@vueuse/core';
import { ref, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { getAllPermissionList, savePermissionMenu, updatePermissionMenu } from '@/api/permission';
import { formSchemas } from '../config';
import { treeToList } from '@/utils/flatTree';
export default {
  __name: 'Menu',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const cascaderData = computed(() => {
      return [{
        id: '0',
        remark: '无父级菜单',
        name: 'top'
      }, ...props.data];
    });
    const sort = computed(() => {
      if (!props.data.length) return 1;
      const arr = treeToList(props.data, 'childSysMenus');
      return arr.length + 1;
    });
    const props1 = {
      checkStrictly: true,
      children: 'childSysMenus',
      label: 'remark',
      value: 'id'
      // eslint-disable-next-line
    };
    const originFormData = {};
    const handleChange1 = val => {
      console.log('val:', val);
    };
    formSchemas.forEach(item => {
      originFormData[item['field']] = item['defaultValue'];
    });

    // console.log(originFormData)
    // 表单数据
    const formData = ref(originFormData);
    const options = ref([]);
    const resetForm = () => {
      formData.value = originFormData;
      options.value = [];
    };
    const dataLoading = ref(false);
    watch(() => props.model, async val => {
      if (val) {
        var _val$permissionId, _val$permissionId2;
        dataLoading.value = true;
        const res = await getAllPermissionList();
        const permission = val.permissionId ? (_val$permissionId = val.permissionId) === null || _val$permissionId === void 0 ? void 0 : _val$permissionId.split(',').map(item => {
          var _res$find;
          return {
            id: item,
            name: (_res$find = res.find(val => val.id === item)) === null || _res$find === void 0 ? void 0 : _res$find.name
          };
        }) : [];
        const permissionId = val.permissionId ? (_val$permissionId2 = val.permissionId) === null || _val$permissionId2 === void 0 ? void 0 : _val$permissionId2.split(',').map((item, index) => {
          var _val$permissionName;
          return (_val$permissionName = val.permissionName) === null || _val$permissionName === void 0 ? void 0 : _val$permissionName.split(',')[index];
        }) : [];
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val)),
          permissionId,
          permission
        };
        dataLoading.value = false;
      } else {
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const loading = ref(false);
    const handleAddNewData = useDebounceFn(async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          loading.value = true;
          try {
            if (!props.model) {
              await savePermissionMenu({
                ...formData.value,
                parentId: formData.value.parentId.length ? formData.value.parentId[formData.value.parentId.length - 1] : formData.value.parentId,
                sort: sort.value,
                permissionId: formData.value.permissionId.length ? formData.value.permissionId.join(',') : ''
              });
            } else {
              var _formData$value$permi, _formData$value$permi2;
              (_formData$value$permi = formData.value.permissionId) === null || _formData$value$permi === void 0 || _formData$value$permi.forEach((item, index) => {
                const temp = formData.value.permission.find(val => val.name === item);
                if (temp) {
                  formData.value.permissionId[index] = temp.id;
                }
              });

              // 去重
              if ((_formData$value$permi2 = formData.value.permissionId) !== null && _formData$value$permi2 !== void 0 && _formData$value$permi2.length) {
                formData.value.permissionId = Array.from(new Set(formData.value.permissionId));
              }
              const parentId = typeof formData.value.parentId === 'string' ? formData.value.parentId : formData.value.parentId[formData.value.parentId.length - 1];
              if (parentId === props.model.id) {
                return ElMessage.error('该菜单不能作为该菜单父菜单');
              }
              await updatePermissionMenu({
                ...formData.value,
                parentId,
                permissionId: formData.value.permissionId.length ? formData.value.permissionId.join(',') : ''
              });
            }
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
            isVisible.value = false;
          } catch (error) {
            console.log(error);
          } finally {
            loading.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    }, 300);
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    const selectLoading = ref(false);
    const remoteMethod = useDebounceFn(async value => {
      if (!value) return;
      selectLoading.value = true;
      const res = await getAllPermissionList({
        keyword: value
      });
      options.value = res;
      selectLoading.value = false;
    }, 300);
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '新增页面权限' : '修改页面权限',
        width: "60%",
        onClosed: closed,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(handleAddNewData),
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        }, 8, ["onClick", "loading"])])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formSchemas), (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.component === 'Input' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'InputTextArea' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                placeholder: item.placeholder,
                type: "textarea",
                autosize: {
                  minRows: 5
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Radio' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.radioArr, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'Cascader' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: item.label,
              prop: item.field,
              rules: item.rules
            }, {
              default: _withCtx(() => [_createVNode(_component_el_cascader, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                onChange: handleChange1,
                options: cascaderData.value,
                clearable: "",
                props: props1,
                "show-all-levels": false
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])]),
              _: 2
            }, 1032, ["label", "prop", "rules"])) : _createCommentVNode("", true), item.component === 'SelectSearch' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 4,
              label: "后端权限",
              prop: item.field
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: formData.value[item.field],
                "onUpdate:modelValue": $event => formData.value[item.field] = $event,
                multiple: "",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                placeholder: "请输入后端权限关键字",
                "remote-method": _unref(remoteMethod),
                loading: selectLoading.value,
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "loading"])]),
              _: 2
            }, 1032, ["prop"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, dataLoading.value]])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};